module.exports = __webpack_public_path__ + "img/partido-politico-nacional-peru-libre.34bae939.png";